import {
  buildTestIds,
  getClientBranchId,
  sortListShipping,
  useValidateClientBranchChange,
} from "application";
import { isPageReloadByZipCodeSearch } from "application/hooks/validateClientBranchChange/pageReload";
import { ButtonSearchZipCode, Skeleton } from "components";
import { cookie, gtag, shippingApi } from "implementations";
import { useCallback, useEffect, useState } from "react";
import { SortDataType } from "typing";
import { useGtagViewShippingOptions } from "./hooks/viewShippingOptions";
import {
  BoxInfo,
  BoxMain,
  ConditionText,
  Container,
  FlexCenterRow,
  ShippingConditionsTexts,
  TextDescription,
  TextInvalidZipCode,
  TitleInvalidZipCode,
} from "./styles";
import { InfoShippingBox } from "./subComponents";
import {
  BoxInfoShipping,
  FlagShipping,
  ShippingCircleIcon,
} from "./subComponents/ InfoShippingBox/styles";

interface ViewZipCodeSearchProps {
  quantityProductSelected: number;
  packingLevel?: number;
  idProduct?: number | string;
  description?: string;
  sellerId: number;
}

const ViewZipCodeSearch = ({
  quantityProductSelected = 0,
  packingLevel = 0,
  idProduct,
  sellerId,
  description,
}: // gabriel.lenon reduzir complexidade
// eslint-disable-next-line sonarjs/cognitive-complexity
ViewZipCodeSearchProps) => {
  const [zipCode, setZipCode] = useState<string>("");
  const [isToFetchZipCode, setIsToFetchZipCode] = useState<boolean>(false);
  const [, setHasData] = useState<boolean>();

  const branchId = getClientBranchId(cookie);

  const formattedZipCode = zipCode?.replace(/\D/g, "");

  const { branchIdByZipCode, isToReloadPage, isChangingClientLocation } =
    useValidateClientBranchChange(formattedZipCode, shippingApi, cookie);

  const isToGetZipCodeAvailability = Boolean(
    (zipCode || isToFetchZipCode || Boolean(isPageReloadByZipCodeSearch())) &&
      /\d{5}-?\d{3}/.test(zipCode) &&
      branchIdByZipCode &&
      !isToReloadPage &&
      !isChangingClientLocation
  );

  const {
    data,
    isLoading,
    error: getShippingOptionsError,
  } = shippingApi.getZipCodeAvailability(
    String(idProduct),
    String(quantityProductSelected),
    String(packingLevel),
    formattedZipCode,
    branchId,
    sellerId,
    isToGetZipCodeAvailability
  );

  let sortListData: SortDataType = {
    delivery: [],
    pickUpAtTheStore: [],
  };

  if (data?.length) {
    sortListData = sortListShipping(data);
  }

  const handleStatusUpdate = useCallback(() => {
    setIsToFetchZipCode(false);

    if (isLoading) {
      setHasData(true);
    } else if (!data?.length) {
      setHasData(false);
    }
  }, [data?.length, isLoading]);

  useEffect(() => {
    setIsToFetchZipCode(true);
  }, [quantityProductSelected]);

  useEffect(() => {
    handleStatusUpdate();
  }, [handleStatusUpdate, isLoading]);

  const isConsultingZipCodeAvailability =
    formattedZipCode?.length === 8 &&
    (isLoading ||
      isPageReloadByZipCodeSearch() ||
      !branchIdByZipCode ||
      isToReloadPage);

  useGtagViewShippingOptions(
    gtag,
    data,
    zipCode.replace("-", ""),
    description,
    idProduct
  );

  return (
    <Container {...buildTestIds("view-zipcode-search")}>
      <BoxMain {...buildTestIds("view-zipcode-search-box-main")}>
        <TextDescription
          {...buildTestIds("view-zipcode-search-text-description")}
        >
          Consultar prazo e valor do frete
        </TextDescription>
        <ButtonSearchZipCode
          {...buildTestIds("view-zipcode-search-button-search")}
          returnInfoClickButton={setZipCode}
          isLoading={isLoading}
          returnWithHyphen
        />
      </BoxMain>
      <BoxInfo {...buildTestIds("view-zipcode-search-box-info")}>
        {isConsultingZipCodeAvailability ? (
          <BoxInfoShipping
            {...buildTestIds("zipcode-search-box-info-shipping")}
          >
            <FlagShipping
              {...buildTestIds("view-zipcode-search-flag-shipping")}
            >
              <ShippingCircleIcon
                {...buildTestIds("view-zipcode-search-shipping-circle-icon")}
              >
                <Skeleton count={1} height={50} width={50} />
              </ShippingCircleIcon>
              <FlexCenterRow>
                <Skeleton count={1} height={15} width={150} />
              </FlexCenterRow>
            </FlagShipping>
            <FlexCenterRow>
              <Skeleton type="basic" count={1} height={30} width={80} />
              <Skeleton type="basic" count={1} height={30} width={80} />
              <Skeleton type="basic" count={1} height={30} width={80} />
            </FlexCenterRow>
            <FlexCenterRow>
              <Skeleton type="basic" count={1} height={30} width={80} />
              <Skeleton type="basic" count={1} height={30} width={80} />
              <Skeleton type="basic" count={1} height={30} width={80} />
            </FlexCenterRow>
          </BoxInfoShipping>
        ) : sortListData?.pickUpAtTheStore?.length ||
          sortListData?.delivery?.length ? (
          <>
            {sortListData?.pickUpAtTheStore?.length > 0 && (
              <InfoShippingBox
                shippingInfo={sortListData.pickUpAtTheStore}
                shippingType="pickUpInStore"
              />
            )}
            {sortListData?.delivery?.length > 0 && (
              <InfoShippingBox
                shippingInfo={sortListData.delivery}
                shippingType="delivery"
              />
            )}
            <ShippingConditionsTexts>
              <ConditionText {...buildTestIds("freight-description-text")}>
                A data estimada de entrega pode variar com a aprovação do
                pagamento, que costuma ser processado em até 3 horas, mas pode
                levar até 72 horas.
              </ConditionText>
              <ConditionText {...buildTestIds("freight-description-text")}>
                O frete é estimado para sua região. Confira o valor final na
                conclusão do pedido.
              </ConditionText>
            </ShippingConditionsTexts>
          </>
        ) : getShippingOptionsError ? (
          <>
            <TitleInvalidZipCode {...buildTestIds("title-invalid-zipcode")}>
              Consulte o frete ao finalizar o pedido
            </TitleInvalidZipCode>
            <TextInvalidZipCode {...buildTestIds("text-invalid-zipcode")}>
              Devido ao alto volume de acessos, verifique as opções de frete na
              página de finalização da compra.
            </TextInvalidZipCode>
          </>
        ) : !isLoading && formattedZipCode?.length === 8 ? (
          <>
            <TitleInvalidZipCode {...buildTestIds("title-invalid-zipcode")}>
              Frete não encontrado
            </TitleInvalidZipCode>
            <TextInvalidZipCode {...buildTestIds("text-invalid-zipcode")}>
              Infelizmente não foram encontradas formas de entrega disponíveis
              para esse CEP.
            </TextInvalidZipCode>
          </>
        ) : null}
      </BoxInfo>
    </Container>
  );
};

export default ViewZipCodeSearch;
